<template>
  <div class="faq-page">
    <div class="question"><i class="el-icon-question"></i>环保小智提供了哪些功能？</div>
    <div class="answer">
      <div class="answer-content">
        1、文件查找；<br/>2、目录检索；<br/>3、文件查看；<br/>4、收藏夹管理；<br/>5、信用平台查询；<br/>6、环保计算；<br/>后续会增加更多功能
      </div>
    </div>

    <div class="question"><i class="el-icon-question"></i>是否需要手机号注册才能查看文件？</div>
    <div class="answer">是的，查看文件功能需要用户登录后才可使用</div>

    <div class="question"><i class="el-icon-question"></i>目前只能通过手机号注册账号吗？</div>
    <div class="answer">是的，目前只提供手机号注册的功能</div>

    <div class="question"><i class="el-icon-question"></i>手册相关文件，例如产排污系数手册打开后空白怎么办？</div>
    <div class="answer">需要到设置里面打开缓存目录，找到对应的.chm文件，手动打开，并将「打开此文件前总是询问」取消勾选状态，下次就可以直接在环保小智中打开了</div>

    <div class="question"><i class="el-icon-question"></i>注册成功后，点击查看文件后，没有成功打开文件怎么办？</div>
    <div class="answer">因为软件对电脑存储访问权限问题，请退出软件，使用管理员权限重新打开软件后，再次尝试查看文件</div>

    <div class="question"><i class="el-icon-question"></i>环保小智对操作系统的支持？</div>
    <div class="answer">windows电脑支持win7及以上系统；环保小智不支持windows Xp系统</div>

    <div class="question"><i class="el-icon-question"></i>环保小智是否支持自动更新？</div>
    <div class="answer">支持，在关于菜单中可手动检查更新；有新版本可用的话，点击更新，下载安装包后安装，会自动覆盖老版本</div>

    <div class="question"><i class="el-icon-question"></i>windows电脑安装建议</div>
    <div class="answer">安装时，选择「仅为我安装」</div>

    <div class="question"><i class="el-icon-question"></i>mac电脑安装建议</div>
    <div class="answer">安装时报「macOS无法验证此App不包含恶意软件」等错误时，参考<a target="_blank" href="https://blog.csdn.net/mhsszm/article/details/106116614">这里</a>解决</div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss">
.faq-page {
  .question {
    font-size: 16px;
    margin: 8px 0;
  }
  .answer {
    text-indent: 2em;
    color: #606266;
    .answer-content {
      text-indent: 0;
      padding-left: 28px;
    }
  }
}
</style>
